<div id="order-history-container" class="row h-100">
    <div class="col-12" id="header-order-history" *ngIf="!isLoading">
        <span class="title-order-history">{{getLocalizationString("Order_History", "Order History")}}</span>
    </div>
    <div class="col-12" id="body-order-history-loader" *ngIf="isLoading">
        <div id="order-history-spinner">
            <sol-spinner [showSpinner]="true"></sol-spinner>
        </div>
    </div>
    <div class="col-12" id="body-order-history-accordion" *ngIf="!isLoading && pspos.historyOrders.length > 0">
        <div class="col-12" id="body-order-history-loader-client-side" *ngIf="isLoadingClientSide">
            <div>
                <sol-spinner [showSpinner]="true"></sol-spinner>
            </div>
        </div>
        <overlay-scrollbars  [options]="filterScrollOptions" (osScroll)="scrollEvent()" id="body-order-history-scroollbar">
            <div class="w-100 h-100" id="body-order-history-scroollbar-container">
                <mat-accordion [multi]="true">
                    <mat-expansion-panel
                        *ngFor="let item of ordersClientSide" [id]="'cat-'+ item.PointStoreOrderID">
                        <mat-expansion-panel-header (click)="customToggleEvent('cat-'+ item.PointStoreOrderID, $event)">
                            <div class="row body-order-history-accordion-title">
                                <div class="col-9">
                                    <span>{{getLocalizationString("Order_Number", "Order number")}}:
                                        <strong class="body-order-history-accordion-title-number">
                                            {{item.PointStoreOrderID}}
                                        </strong> | {{item.DateOrdered | date: 'MMM dd, y'}}
                                    </span>
                                </div>
                                <div class="col-3 text-left">
                                    <span class="body-order-history-total">{{getLocalizationString("Total", "Total")}}:
                                        <strong>
                                            {{getOrderTotal(item.OrderTotal) }} {{+getOrderTotal(item.OrderTotal) === 1 ? getLocalizationString("Coin", "Coin") : getLocalizationString("Coins", "Coins")}}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                        </mat-expansion-panel-header>
                        <ng-container [ngTemplateOutlet]="tabTemplate"
                            [ngTemplateOutletContext]="{item:item.ProductsCollection}">
                        </ng-container>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </overlay-scrollbars>
    </div>
    <div class="col-12" id="body-order-history-empty" *ngIf="!isLoading && pspos.historyOrders.length == 0">
        <div>
            <svg>
                <use href="../App_Themes/Cxone/icons/empty-state.svg#empty-state"></use>
            </svg>
        </div>
        <div>
            <span   class="text-center empty-orders-message" 
                    cvLocalizedText langSection="MarketPlace"
                    langKey="No_Orders_Found">No orders found</span>
        </div>
    </div>
</div>
<ng-template #tabTemplate let-item="item">
    <div class="row body-order-history-row" *ngFor="let itemDetail of item; let i = index">
        <div class="body-order-history-col d-flex flex-row">
            <div>
                <img class="body-order-history-product-image" [src]="getImageSrc(itemDetail)" alt="" *ngIf="!isCxOne">

                <img class="body-order-history-product-image" [src]="getImageSrc(itemDetail)" alt="" 
                    *ngIf="isCxOne && 
                    (itemDetail._PointStoreProductOrderedDTO.ProductImageID != 0 && itemDetail._PointStoreProductOrderedDTO.ProductImageID != null ||
                    !isEmptyOrNullVariation(itemDetail._PointStoreProductOrderedDTO))">
            
                <div *ngIf="isCxOne && ((itemDetail._PointStoreProductOrderedDTO.ProductImageID == 0 || itemDetail._PointStoreProductOrderedDTO.ProductImageID == null) &&
                            isEmptyOrNullVariation(itemDetail._PointStoreProductOrderedDTO))" 
                    class="order-product-img-svg d-flex flex-column justify-content-center align-items-center">
                    <svg class="not-available">
                        <use href="../App_Themes/CXone/icons/not-available-image.svg#not-available-image"></use>
                    </svg>
                </div> 
            </div>
            <div class="body-order-history-product-column">
                <div>
                    <span class="body-order-history-product-title">
                        {{itemDetail._PointStoreProductOrderedDTO.Title}}
                    </span>
                </div>
                <div *ngIf="getVariationDescription(itemDetail) !== 'N/A'">
                    <span> {{getLocalizationString(getVariationName(itemDetail), getVariationName(itemDetail))}}:
                        <strong>
                            {{getVariationDescription(itemDetail)}}
                        </strong>
                    </span>
                </div>
                <div>
                    <span>{{getLocalizationString("Quantity", "Quantity")}}:
                        <strong>
                            {{itemDetail._PointStoreProductOrderedDTO.ProductQuantity}}
                        </strong>
                    </span>
                </div>
                <div>
                    <span>{{getLocalizationString("Price_Per_Item", "Price per Item")}}:
                        <strong>
                            {{itemDetail._PointStoreProductOrderedDTO.ProductCost}} {{itemDetail._PointStoreProductOrderedDTO.ProductCost === 1 ? getLocalizationString("Coin",
                            "Coin") : getLocalizationString("Coins", "Coins")}}
                        </strong>
                        <svg class="icon-12 body-order-history-product-icon"
                            popover="{{getLocalizationString('Current_Price_May_Vary', 'This price was during the sale period. The current price may vary.')}}"
                            container="body" placement="bottom" triggers="mouseenter:mouseleave"
                            *ngIf="isPriceChanged(itemDetail)">
                            <use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use>
                        </svg>
                    </span>
                </div>
                <div class="body-order-history-product-status-container">
                    <div>
                        <svg class="icon-16 body-order-history-product-status-icon {{getStatus(itemDetail).color}}"
                            [innerHTML]="getStatus(itemDetail).iconHTML"></svg>
                    </div>
                    <div>
                        <span class="body-order-history-product-status-text">
                            {{getLocalizationString(getStatus(itemDetail).keyLocalization, getStatus(itemDetail).name)}}
                        </span>
                    </div>
                </div>
                <div>
                    <button class="body-order-history-product-button"
                        [disabled]="!allowBuyAgain(itemDetail._PointStoreProductOrderedDTO.PointStoreProductID, itemDetail._PointStoreProductOrderedDTO.Variation)"
                        (click)="reorderProduct(itemDetail._PointStoreProductOrderedDTO)">
                        {{getLocalizationString("Reorder", "Reorder")}}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 body-order-history-col" *ngIf="item.length > 1 && item.length > (i + 1)">
            <hr>
        </div>
    </div>
</ng-template>
